import { useTranslation } from 'react-i18next';
import {
  Button,
  ButtonsWrapper,
  CheckboxSelect,
  Form,
  Modal,
  SelectInput,
} from '@thinknet-gmbh/platform-common-ui';

import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useGetDocumentLabelsByCompany } from 'src/hooks/documents-labels/get-documents-labels.hook';
import { useUpsertEmployeeDocument } from 'src/hooks/employees/create-employee-document.hook';
import { useRouteQuery } from 'src/common/helpers';
import { useGetEmployeeDocuments } from 'src/hooks/employees/get-employee-documents.hook';

const CreateDocument = ({ isOpened, onClose }: { isOpened: boolean; onClose: () => void }) => {
  const { t } = useTranslation(['settings', 'common']);
  const query = useRouteQuery();
  const _id: string = query.get('id') || '';

  const currentCompanyId = useGetCurrentCompanyId();
  const { documentsLabels } = useGetDocumentLabelsByCompany(currentCompanyId);
  const { documents } = useGetEmployeeDocuments(_id);
  const upsertEmployeeDocument = useUpsertEmployeeDocument({ onSuccess: onClose });

  const onFinish = (values: any) => {
    upsertEmployeeDocument({ variables: { payload: { memberId: _id, ...values } } });
  };

  return (
    <Modal
      isOpened={isOpened}
      onClose={onClose}
      title={t('settings:documents.buttons.createNewDocument')}
    >
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="documentLabelId"
          label={t('settings:documentsLabels.labelsName')}
          rules={[
            {
              required: true,
              message: t('settings:documentsLabels.validation.labelsNameRequired'),
            },
          ]}
        >
          <SelectInput placeholder={t('settings:documentsLabels.contract')}>
            {documentsLabels.map(({ _id, name }: any) => (
              <SelectInput.Option key={_id} value={_id}>
                {name}
              </SelectInput.Option>
            ))}
          </SelectInput>
        </Form.Item>
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue }) => {
            const document = documentsLabels.find(
              (item: any) => item._id === getFieldValue('documentLabelId')
            );

            return (
              <Form.Item
                name="documentTemplatesIds"
                label={t('settings:documents.labels.documentTemplate')}
                rules={[
                  { required: true, message: t('settings:documents.errors.templateRequired') },
                ]}
              >
                <CheckboxSelect
                  optionData={
                    document
                      ? document.documentTemplates
                          .filter(
                            // exclude already selected document templates
                            ({ _id }: any) =>
                              !documents
                                .find((d: any) => d.documentLabelId === document._id)
                                ?.documentTemplatesIds.includes(_id)
                          )
                          .map(({ _id, title }: any) => ({
                            value: _id,
                            label: title,
                          }))
                      : []
                  }
                  placeholder={t('settings:documentsLabels.employmentContract')}
                />
              </Form.Item>
            );
          }}
        </Form.Item>

        <ButtonsWrapper marginTop={16}>
          <Button type="primary" htmlType="submit">
            {t('common:buttons.save')}
          </Button>
          <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </Modal>
  );
};

export default CreateDocument;
